import { State } from "./state";
import { storeInit } from "../../../Store";
export const initialAbout: State.Data = {
  siteId: "",
  prjVersion: "",
  productKey: "",
  product: "",
  mqxVersion: "",
  atxVersion: "",
  sslVersion: "",
  webVersion: "",
  mfg: "",
  user: "",
  mac: "",
  sid: "",
  policies: []
};

export const initial: State.Props = storeInit<State.Data>(initialAbout);

export default initial;
